import Cookies from "js-cookie";
import axios from 'axios'


const config_env = require(`../build/${process.env.BUILD_ENV}.js`)
const customAxios = axios.create({
    baseURL: config_env.BASE_URL,
    timeout: Infinity,
    headers: {"Authorization": "Bearer " + Cookies.get('TipDM-Login-Token')}
})

const basePath = '/api/review/plan'


/**
 * 根据答题卡id查询批阅结果
 * @param answerSheetId
 * @returns {*}
 */
export function exportAnswer(examId, param) {
    return customAxios.get(`${basePath}/${examId}/examPaper/answers/downloads?objective=${param.objective}&subjectivity=${param.subjectivity}`)
}

export function getPackageStatus(ticket) {
    return customAxios.get(`${basePath}/${ticket}/status`)
}
